const autoNgTemplateLoaderTemplate1 = require('./endpointsDatatable.html');

angular.module('portainer.app').component('endpointsDatatable', {
  templateUrl: autoNgTemplateLoaderTemplate1,
  controller: 'EndpointsDatatableController',
  bindings: {
    titleText: '@',
    titleIcon: '@',
    tableKey: '@',
    orderBy: '@',
    reverseOrder: '<',
    removeAction: '<',
    retrievePage: '<',
  },
});
